<template>
  <div>
    <h5>Pengaturan LMS / Kursus Online</h5>
    <div class="form-check mb-3">
      <input id="lms_enabled" type="checkbox" class="form-check-input" v-model="form.is_enabled">
      <label for="lms_enabled" class="form-check-label">Aktifkan fitur kursus online (LMS)</label>
    </div>
    <p class="text-muted small">Setelah aktif, kelola kursus di halaman ini. Siswa dapat mendaftar via katalog toko.</p>
    <div class="text-right mt-3">
      <button class="btn btn-secondary mr-2" @click="$emit('close')">Batal</button>
      <button class="btn btn-primary" @click="save" :disabled="saving">
        <span v-if="saving" class="spinner-border spinner-border-sm mr-1"></span>
        Simpan
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LMSSettingsModal',
  props: { shopId: { type: Number, required: true } },
  data() {
    return { form: { is_enabled: false }, saving: false };
  },
  mounted() { this.load(); },
  methods: {
    async load() {
      try {
        const r = await this.$store.dispatch('shop_lms/lms_get_settings', this.shopId);
        const s = r.data.data.settings || {};
        this.form.is_enabled = s.is_enabled === 1;
      } catch (e) { /* noop */ }
    },
    async save() {
      this.saving = true;
      try {
        await this.$store.dispatch('shop_lms/lms_update_settings', {
          shopId: this.shopId,
          settings: { is_enabled: this.form.is_enabled ? 1 : 0 },
        });
        this.$toast.success('Pengaturan LMS disimpan');
        this.$emit('saved');
        this.$emit('close');
      } catch (e) {
        this.$toast.error(e.response?.data?.message || 'Gagal menyimpan');
      } finally { this.saving = false; }
    },
  },
};
</script>
